import * as React from 'react';
import { styled } from '@glitz/react';

export const Spinner = styled((props: React.SVGAttributes<SVGElement>) => {
  return (
    <Svg width="1.5em" height="1.5em" viewBox="0 0 50 50" {...props}>
      <Circle cx={25} cy={25} r={20} fill="none" stroke="currentColor" strokeWidth={5} />
    </Svg>
  );
});

const Svg = styled.svg({
  animation: {
    name: {
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
    duration: 2000,
    timingFunction: 'linear',
    iterationCount: 'infinite',
  },
});

const Circle = styled.circle({
  animation: {
    name: {
      '0%': {
        strokeDasharray: '1 200',
        strokeDashoffset: 0,
      },
      '50%': {
        strokeDasharray: '89 200',
        strokeDashoffset: '-35',
      },
      '100%': {
        strokeDasharray: '89 200',
        strokeDashoffset: '-124',
      },
    },
    duration: 1500,
    timingFunction: 'ease-in-out',
    iterationCount: 'infinite',
  },
});
